/*
 * Viewport breakpoints in JavaScript, matching Tailwind's default scale so
 * `useMediaQuery` agrees with the `sm:` / `md:` classes on the same elements.
 */

/** Tailwind `md` (48rem): the desktop layout — nav rail, framed pages, title-bar tabs. Below it, mobile. */
export const DESKTOP_LAYOUT_QUERY = '(width >= 48rem)';

/**
 * Below Tailwind `lg` (64rem), down to Electron's 900 px minimum: the open sidebar folds to its
 * rail while the side panel is open, so the panel docks beside the conversation (D2).
 */
export const NARROW_DESKTOP_QUERY = '(width < 64rem)';
